import script from "./CalendarEventForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarEventForm.vue?vue&type=script&setup=true&lang=js"

import "./CalendarEventForm.vue?vue&type=style&index=0&id=2d025a94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d025a94"]])

export default __exports__